// extracted by css-extract-rspack-plugin
export default {"newSegmentButton":"newSegmentButton-bTY67B","segmentChip":"segmentChip-X2NLXQ","segmentChipRemove":"segmentChipRemove-vITV9D"};